msgid ""
msgstr ""
"POT-Creation-Date: 2023-08-30 18:51+0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: hy\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/domains/buy-ticket/select-seats.tsx:83
msgid "{remainingSeatCount, plural, =0 {Места выбраны} =1 {Осталось выбрать 1 место} =2 {Осталось выбрать 2 места} =3 {Осталось выбрать 3 места} =4 {Осталось выбрать 4 места} other {}}"
msgstr "{remainingSeatCount, plural, =0 {Նստատեղերը ընտրված են} =1 {Մնացել է 1 տեղ ընտրել} =2 {Մնացել է 2 տեղ ընտրել} =3 {Մնացել է 3 տեղ ընտրել} =4 {Մնացել է 4 տեղ ընտրել} other {}}"

#: src/components/train-route-info/train-route-info.tsx:31
msgid "Hч mmм"
msgstr "Hժ mmր"

#: src/domains/sign-in/sign-in.tsx:47
#: src/domains/sign-up/sign-up.tsx:36
msgid "Авторизация не удалась"
msgstr "Ավտորիզացիան չհաջողվեց"

#: src/domains/buy-ticket/buy-ticket.tsx:227
#: src/domains/buy-ticket/buy-ticket.tsx:228
#: src/domains/buy-ticket/select-payment-type.tsx:10
#: src/domains/buy-ticket/select-payment-type.tsx:10
msgid "Банковской картой"
msgstr "Բանկային քարտով"

#: src/pages/ticket-details/ticket-details.page.tsx:188
msgid "Билет не найден. Попробуйте обновить страницу или вернуться к списку билетов"
msgstr "Տոմսը չի գտնվել։ Փորձեք թարմացնել էջը կամ վերադառնալ տոմսերի ցանկին"

#: src/pages/my-tickets/my-tickets.page.tsx:66
msgid "Билеты пока что отсутствуют"
msgstr "Տոմսերը դեռ հասանելի չեն"

#: src/pages/sign-up/sign-up.page.tsx:50
msgid "в личном кабинете"
msgstr "անձնական գրասենյակում"

#: src/domains/push-notify/push-notify-settings.tsx:38
msgid "В настройках вашего браузера запрещено показывать уведомления для этого приложения"
msgstr "Ձեր դիտարկիչի կարգավորումները թույլ չեն տալիս ցուցադրել ծանուցումներ այս հավելվածի համար."

#: src/domains/push-notify/push-notify-settings.tsx:30
msgid "В настройках вашего телефона запрещено показывать уведомления для этого приложения"
msgstr "Ձեր հեռախոսի կարգավորումները թույլ չեն տալիս ցույց տալ ծանուցումներ այս հավելվածի համար."

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:108
#~ msgid "В рамках одной покупки можно приобрести только один билет"
#~ msgstr "Մեկ գնումով  կարելի է ձեռք բերել միայն մեկ տոմս"

#: src/pages/ticket-details/ticket-details.page.tsx:226
#~ msgid "вагон"
#~ msgstr "վագոն"

#: src/domains/buy-ticket/select-seats.tsx:149
msgid "Вагон"
msgstr "Վագոն"

#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:29
msgid "Вагон и место"
msgstr "Վագոնը և տեղը"

#: src/domains/push-notify/push-notify-settings.tsx:26
msgid "Ваше устройство не поддерживает Web Push уведомления"
msgstr "Ձեր սարքը չի աջակցում Web Push ծանուցումները."

#: src/domains/available-routes/ui/select-stations.tsx:115
msgid "Введите название станции"
msgstr "Մուտքագրեք կայարանի անվանումը"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:36
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:43
msgid "Вернуть билет"
msgstr "Վերադարձնել տոմսը"

#: src/App.tsx:69
msgid "Версия"
msgstr "Տարբերակ"

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:29
msgid "Вид тарифа"
msgstr "Սակագնի տեսակը"

#: src/domains/push-notify/push-notify-access-request.tsx:58
msgid "Включить уведомления"
msgstr "Միացնել ծանուցումները"

#: src/domains/buy-ticket/agreement.tsx:16
msgid "Внимание!"
msgstr "ՈՒՇԱԴՐՈՒԹՅՈՒՆ."

#: src/domains/sign-in/sign-in.tsx:135
#: src/features/main-side-menu/main-side-menu.tsx:73
#: src/pages/sign-up/sign-up.page.tsx:91
msgid "Войти"
msgstr "Մուտք գործել"

#: src/pages/reset-password/reset-password.page.tsx:176
msgid "Войти в личный кабинет"
msgstr "Մուտք գործել  անձնական գրասենյակ"

#: src/pages/order-status/order-status.page.tsx:328
msgid "Все оплаченные билеты доступны в разделе <0>Мои билеты</0>."
msgstr "Բոլոր վճարված տոմսերը հասանելի են <0> Իմ տոմսերը</0> բաժնում։"

#: src/pages/main/main.page.tsx:106
msgid "Вход"
msgstr "Մուտք"

#: src/pages/sign-in/sign-in.page.tsx:49
msgid "Вход в личный кабинет"
msgstr "Մուտք գործել  անձնական գրասենյակ"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:37
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:46
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:59
msgid "Вы уверены, что хотите отменить заказ?"
msgstr "Վստահ եք՞ որ ուզում եք չեղարկել պատվերը"

#: src/domains/buy-ticket/select-seats.tsx:63
#: src/domains/buy-ticket/select-seats.tsx:68
msgid "Выберите место"
msgstr "Ընտրեք տեղը"

#: src/pages/buy-tickets/buy-tickets.tsx:24
msgid "Выбор мест"
msgstr "Տեղերի ընտրություն"

#: src/pages/main/main.page.tsx:112
msgid "Выбор языка"
msgstr "Լեզվի ընտրություն"

#: src/domains/buy-ticket/buy-ticket.tsx:244
msgid "Выбрать место"
msgstr "Տեղի ընտրություն"

#: src/pages/logout/logout.page.tsx:60
msgid "Выполняется выход из приложения..."
msgstr "Կատարվում է ելք հավելվածից"

#: src/domains/buy-ticket/redirect-to-bank.tsx:18
msgid "Выполняется переход на сайт банка для оплаты. Если этого не произошли, нажмите на ссылку"
msgstr "Կատարվում է անցում բանկի կայք վճարման համար:Եթե ​​դա տեղի չի ունենում, հետևեք հղումին"

#: src/features/main-side-menu/main-side-menu.tsx:64
msgid "Выход"
msgstr "Ելք"

#: src/domains/buy-ticket/select-seats.tsx:78
msgid "Голова поезда находится в верху экрана"
msgstr "Գնացքի գլուխը գտնվում է էկրանի վերևում:"

#: src/pages/ticket-details/ticket-details.page.tsx:116
#: src/pages/ticket-details/ticket-details.page.tsx:141
#: src/pages/ticket-details/ticket-details.page.tsx:224
msgid "Данные билета"
msgstr "Տոմսի տվյալները"

#: src/pages/order-details/order-details.page.tsx:85
#: src/pages/order-details/order-details.page.tsx:122
#: src/pages/order-details/order-details.page.tsx:169
#: src/pages/order-details/order-details.page.tsx:224
#: src/pages/order-status/order-status.page.tsx:93
#: src/pages/order-status/order-status.page.tsx:118
#: src/pages/order-status/order-status.page.tsx:153
#: src/pages/ticket-details/ticket-details.page.tsx:177
#: src/pages/ticket-details/ticket-details.page.tsx:302
msgid "Данные заказа"
msgstr "Պատվերի տվյալները"

#: src/domains/buy-ticket/pay-confirm.tsx:23
#: src/pages/order-status/order-status.page.tsx:358
msgid "Дата"
msgstr "Ամսաթիվ"

#: src/pages/my-tickets/my-tickets.page.tsx:79
#: src/pages/order-details/order-details.page.tsx:45
#: src/pages/ticket-details/ticket-details.page.tsx:78
msgid "Дата заказа"
msgstr "Պատվերի ամսաթիվը"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:162
#: src/domains/available-routes/features/available-routes/available-routes.tsx:163
msgid "День отправления"
msgstr "Մեկնման օր"

#: src/domains/push-notify/push-notify-access-request.tsx:39
msgid "Для получения уведомлений без запуска приложения требуется ваше разрешение. Обещаем не беспокоить вас по пустякам."
msgstr "Պահանջվում է  ձեր թույլտվությունը առանց հավելվածը գործարկելու ծանուցումներ ստանալու համար: Խոստանում ենք ձեզ չանհանգստացնել մանրուքների համար։"

#: src/pages/order-status/order-status.page.tsx:324
msgid "Для просмотра вашего билета нажмите на кнопку ниже."
msgstr "Ձեր տոմսը դիտելու համար սեղմեք ստորև նշված կոճակը"

#: src/domains/push-notify/push-notify-settings.tsx:19
msgid "Для работы уведомлений необходимо добавить приложение на главный экран через меню на панели браузера"
msgstr "Որպեսզի ծանուցումները աշխատեն, դուք պետք է հավելվածն ավելացնեք հիմնական էկրանին՝ դիտարկիչի վահանակի մենյուի միջոցով."

#: src/pages/buy-tickets/buy-tickets.tsx:22
msgid "Добавление пассажиров"
msgstr "Ուղևորների ավելացում"

#: src/pages/order-details/order-details.page.tsx:312
#: src/pages/order-status/order-status.page.tsx:228
msgid "Если у вас не получилось произвести оплату, оплатить заказ можно по ссылке"
msgstr "Եթե ​​չեք կարողանում վճարել, կարող եք վճարել ձեր պատվերը՝ օգտագործելով  հղումը."

#: src/pages/reset-password/reset-password.page.tsx:186
#: src/pages/sign-in/sign-in.page.tsx:80
msgid "Еще не зарегистрированны?"
msgstr "Դեռ գրանցված չե՞ք։"

#: src/domains/shared/refund-fee-express.tsx:41
msgid "За <0>20</0> минут до отправления поезда билет возврату не подлежит."
msgstr "Գնացքի մեկնումից <0>20</0> րոպե առաջ տոմսի վերադարձն արգելափակվում է:"

#: src/pages/my-orders/my-orders.page.tsx:87
msgid "Забронирован"
msgstr "Ամրագրված է"

#: src/pages/sign-in/sign-in.page.tsx:62
#: src/pages/sign-up/sign-up.page.tsx:63
msgid "Забыли пароль?"
msgstr "Մոռացել ե՞ք  գաղտնաբառը"

#: src/pages/order-status/order-status.page.tsx:278
msgid "Заказ был забронирован"
msgstr "Պատվերը ամրագրված է"

#: src/pages/order-status/order-status.page.tsx:283
msgid "Заказ был забронирован и ожидает завершения оплаты"
msgstr "Պատվերը ամրագրված է և սպասում է վճարման ավարտին"

#: src/pages/order-details/order-details.page.tsx:298
#: src/pages/ticket-details/ticket-details.page.tsx:330
msgid "Заказ был забронирован и ожидает оплаты"
msgstr "Պատվերը ամրագրված է և սպասում է վճարմանը"

#: src/pages/order-status/order-status.page.tsx:298
msgid "Заказ был отменен"
msgstr "Պատվերը չեղարկվել է"

#: src/pages/ticket-details/ticket-details.page.tsx:338
msgid "Заказ был отменен. Стоимость оплаченного билета будет возвращена с помощью выбранного способа оплаты (банковская карта)"
msgstr "Պատվերը չեղարկվել է: Վճարված տոմսի արժեքը կվերադարձվի ընտրված վճարման եղանակով (բանկային քարտ)"

#: src/pages/order-details/order-details.page.tsx:276
#: src/pages/order-status/order-status.page.tsx:303
msgid "Заказ был отменен. Сумма заказа вернется на ваш счет"
msgstr "Պատվերը չեղարկվել է:Պատվերի գումարը կվերադարձվի ձեր հաշվին"

#: src/pages/order-status/order-status.page.tsx:319
msgid "Заказ был успешно оплачен"
msgstr "Պատվերը հաջողությամբ վճարվել է"

#: src/pages/order-details/order-details.page.tsx:180
msgid "Заказ не найден. Попробуйте обновить страницу или вернуться к списку заказов"
msgstr "Պատվերը չի գտնվել:Փորձեք թարմացնել էջը կամ վերադառնալ պատվերների ցանկին"

#: src/pages/order-status/order-status.page.tsx:218
msgid "Заказ обрабатывается"
msgstr "Պատվերը մշակվում է"

#: src/pages/order-details/order-details.page.tsx:307
#: src/pages/order-status/order-status.page.tsx:223
#: src/pages/ticket-details/ticket-details.page.tsx:382
msgid "Заказ обрабатывается, ожидаем подтверждения оплаты"
msgstr "Պատվերը մշակվում է, սպասվում է վճարման հաստատում"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:66
msgid "Заказ с ошибкой будет скрыт"
msgstr "Սխալով պատվերը կթաքցվի"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:59
msgid "Заказы"
msgstr "Պատվերներ"

#: src/pages/my-orders/my-orders.page.tsx:142
msgid "Заказы пока что отсутствуют"
msgstr "Պատվերներ դեռ չկան"

#: src/domains/sign-up/sign-up.tsx:173
#: src/pages/reset-password/reset-password.page.tsx:197
#: src/pages/sign-in/sign-in.page.tsx:90
msgid "Зарегистрироваться"
msgstr "Գրանցվել"

#: src/domains/buy-ticket/buy-ticket.tsx:299
#: src/domains/buy-ticket/buy-ticket.tsx:327
msgid "Изменить данные"
msgstr "Փոխել տվյալները"

#: src/domains/buy-ticket/buy-ticket.tsx:271
msgid "Изменить данные пассажиров"
msgstr "Փոխել ուղևորի տվյալները"

#: src/pages/sign-in/sign-in.page.tsx:73
#: src/pages/sign-up/sign-up.page.tsx:74
msgid "Изменить пароль"
msgstr "Փոխել գաղտնաբառը"

#: src/features/main-side-menu/main-side-menu.tsx:54
msgid "История заказов"
msgstr "Պատվերների պատմություն"

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:54
msgid "Итого"
msgstr "Ընդհամենը"

#: src/pages/search/seach-routes-loading.tsx:17
msgid "Ищем доступные маршруты..."
msgstr "Փնտրում եմ հասանելի երթուղիներ"

#: src/domains/push-notify/push-notify-access-request.tsx:32
msgid "Кажется, Вы запретили приложению присылать вам уведомления. Для получения уведомлений зайдите в настройки телефона и разрешите показывать уведомления для \"pass.railway.am\" или Railway AM"
msgstr "   «Թվում է, որ դուք արգելափակել եք հավելվածը ձեզ ծանուցումներ ուղարկելու համար: Ծանուցումներ ստանալու համար անցեք ձեր հեռախոսի կարգավորումներ և թույլ տվեք, որ ծանուցումները ցուցադրվեն \"pass.railway.am\" կամ «Railway AM»-ի համար»"

#: src/domains/push-notify/push-notify-access-request.tsx:26
msgid "Кажется, Вы запретили приложению присылать вам уведомления. Для получения уведомлений зайдите в настройки телефона и разрешите показывать уведомления для Railway AM"
msgstr "   Կարծես դուք արգելափակել եք հավելվածը ձեզ ծանուցումներ ուղարկելու համար: Ծանուցումներ ստանալու համար գնացեք ձեր հեռախոսի կարգավորումներ և թույլատրեք ցույց տալ ծանուցումներ Railway AM-ի համար"

#: src/domains/reset-password/change-pass.form.tsx:59
#: src/domains/sign-up/sign-up.tsx:158
msgid "Код подтверждения"
msgstr "Հաստատման ծածկագիր"

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:118
msgid "Количество пассажиров:"
msgstr "ՈՒղևորների քանակը"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:37
#: src/features/main-side-menu/main-side-menu.tsx:36
#: src/pages/logout/logout.page.tsx:49
msgid "Личный кабинет"
msgstr "Անձնական գրասենյակ"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:150
#: src/domains/buy-ticket/pay-confirm.tsx:26
msgid "Маршрут"
msgstr "Երթուղի"

#: src/pages/search/search.page.tsx:138
msgid "Маршруты не найдены"
msgstr "Երթուղիները չեն գտնվել"

#: src/domains/buy-ticket/select-seats.tsx:95
msgid "Места выбраны"
msgstr "Նստատեղերը ընտրված են"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:50
#: src/features/main-side-menu/main-side-menu.tsx:45
#: src/pages/my-tickets/my-tickets.page.tsx:52
#: src/pages/order-details/order-details.page.tsx:144
#: src/pages/order-details/order-details.page.tsx:289
#: src/pages/order-details/order-details.page.tsx:341
#: src/pages/order-status/order-status.page.tsx:140
#: src/pages/order-status/order-status.page.tsx:200
#: src/pages/order-status/order-status.page.tsx:261
#: src/pages/ticket-details/ticket-details.page.tsx:163
#: src/pages/ticket-details/ticket-details.page.tsx:199
#: src/pages/ticket-details/ticket-details.page.tsx:371
#: src/pages/ticket-details/ticket-details.page.tsx:410
msgid "Мои билеты"
msgstr "Իմ տոմսերը"

#: src/pages/my-orders/my-orders.page.tsx:129
#: src/pages/order-details/order-details.page.tsx:192
msgid "Мои заказы"
msgstr "Իմ պատվերները"

#: src/pages/reset-password/reset-password.page.tsx:134
msgid "Мы отправим код подтверждения на указанный номер телефона"
msgstr "Հաստատման կոդը կուղարկվի նշված հեռախոսահամարին"

#: src/pages/reset-password/reset-password.page.tsx:129
msgid "На следующем шаге нужно ввести код подтверждения и новый пароль"
msgstr "Հաջորդ քայլը հաստատման ծածկագիր և նոր գաղտնաբառ մուտքագրելն է"

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:28
#~ msgid "Название тарифа"
#~ msgstr "Սակագնի անունը"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:171
msgid "Найти билеты"
msgstr "Որոնել տոմսերը"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:81
#: src/domains/push-notify/push-notify.page.tsx:46
msgid "Настройка уведомлений"
msgstr "Ծանուցումների  կարգավորում"

#: src/domains/push-notify/push-notify.page.tsx:46
#~ msgid "Настройки уведомлений"
#~ msgstr "Ծանուցման կարգավորումներ"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:69
msgid "Начальная и конечная станции совпадают"
msgstr "Մեկնման և ժամանման կայարանները համնկնում են"

#: src/components/tickets-count/tickets-count.tsx:70
msgid "Не найдены билеты с тарифами по выбранному маршруту."
msgstr "Ընտրված երթուղով ուղեվարձով տոմսեր չեն գտնվել"

#: src/domains/push-notify/use-push-notify-perms.ts:55
#: src/domains/push-notify/use-push-notify-perms.ts:136
msgid "Не получилось создать подписку на уведомления. Попробуйте перезапустить приложение"
msgstr "Չհաջողվեց ստեղծել ծանուցման բաժանորդագրություն: Փորձեք վերագործարկել հավելվածը"

#: src/domains/push-notify/use-push-notify-perms.ts:234
msgid "Не удалось выполнить подписку в приложении"
msgstr "Չհաջողվեց բաժանորդագրվել հավելվածին"

#: src/pages/buy-tickets/buy-tickets.tsx:54
msgid "Неверные параметры в строке адреса. Начните поиск билетов заново"
msgstr "Սխալ տվյալներ հասցեատողում"

#: src/components/search-route-card/search-route-card-data.tsx:32
msgid "Нет свободных мест"
msgstr "Ազատ տեղեր չկան"

#: src/domains/reset-password/change-pass.form.tsx:69
msgid "Новый пароль"
msgstr "նոր ծածկագիր"

#: src/pages/ticket-details/ticket-details.page.tsx:74
msgid "Номер заказа"
msgstr "Պատվերի համար"

#: src/domains/buy-ticket/pay-confirm.tsx:22
#: src/pages/order-details/order-details.page.tsx:43
#: src/pages/order-status/order-status.page.tsx:354
msgid "Номер платежа"
msgstr "Վճարման համարը"

#: src/pages/ticket-details/trip-data/trip-data.tsx:23
msgid "Номер рейса"
msgstr "Երթուղու համարը"

#: src/domains/reset-password/change-pass.form.tsx:36
#: src/domains/reset-password/login.form.tsx:25
#: src/domains/sign-in/sign-in.tsx:98
#: src/domains/sign-up/sign-up.tsx:117
msgid "Номер телефона"
msgstr "Հեռախոսահամարը"

#: src/pages/order-details/order-details.page.tsx:333
#: src/pages/order-status/order-status.page.tsx:192
#: src/pages/order-status/order-status.page.tsx:253
#: src/pages/ticket-details/ticket-details.page.tsx:362
#: src/pages/ticket-details/ticket-details.page.tsx:401
msgid "Обновить статус"
msgstr "Թարմացնել կարգավիճակը"

#: src/pages/my-orders/my-orders.page.tsx:43
msgid "Ожидает оплаты"
msgstr "Սպասում է վճարմանը"

#: src/pages/order-status/order-status.page.tsx:263
#~ msgid "Он будет сохранен в разделе \"Мои билеты\""
#~ msgstr "Այն կպահպանվի \"Իմ տոմսերը\" բաժնում"

#: src/domains/buy-ticket/pay-confirm.tsx:24
#: src/pages/order-details/order-details.page.tsx:48
#: src/pages/order-status/order-status.page.tsx:361
msgid "Описание"
msgstr "Նկարագրում"

#: src/domains/buy-ticket/buy-ticket.tsx:291
#: src/domains/buy-ticket/buy-ticket.tsx:319
msgid "Оплатить"
msgstr "Վճարել"

#: src/pages/my-orders/my-orders.page.tsx:58
msgid "Оплачен"
msgstr "Վճարված է"

#: src/pages/order-details/order-details.page.tsx:55
msgid "Оплачено"
msgstr "Վճարված է"

#: src/domains/feedback/reviews.page.tsx:170
msgid "Оставить отзыв"
msgstr "Թողնել կարծիք"

#: src/domains/buy-ticket/select-seats.tsx:76
#~ msgid "Осталось выбрать {remainingSeatCount} место"
#~ msgstr "Մնացել է {remainingSeatCount} տեղ ընտրել"

#: src/pages/ticket-details/ticket-details.page.tsx:297
msgid "Отзыв о поездке"
msgstr "Կարծիք ուղևորության մասին"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:68
#: src/domains/feedback/reviews.page.tsx:60
#: src/domains/feedback/reviews.page.tsx:99
msgid "Отзывы"
msgstr "Կարծիքներ"

#: src/domains/feedback/grade-title.ts:12
msgid "Отлично"
msgstr "Գերազանց"

#: src/domains/cabinet/features/tickets/refund-ticket-button.tsx:75
msgid "Отмена"
msgstr "Չեղարկել"

#: src/domains/cabinet/features/tickets/refund-ticket-button.tsx:49
msgid "Отмена заказа"
msgstr "Պատվերի չեղարկում"

#: src/pages/my-orders/my-orders.page.tsx:101
msgid "Отменен"
msgstr "Չեղարկված է"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:73
msgid "Отмененный заказ будет скрыт"
msgstr "Չեղարկված պատվերը կթաքցվի"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:58
msgid "Отменить заказ"
msgstr "Չեղարկել պատվերը"

#: src/domains/reset-password/change-pass.form.tsx:76
#: src/domains/reset-password/login.form.tsx:45
msgid "Отправить код"
msgstr "Ուղարկել ծածկագիրը"

#: src/domains/feedback/add-feedback-form.tsx:75
msgid "Отправить отзыв"
msgstr "Ուղարկել կարծիք"

#: src/pages/order-details/order-details.page.tsx:82
#: src/pages/order-status/order-status.page.tsx:99
#~ msgid "Отсутсвует ID платежа. Купленные билеты можно посмотреть в разделе \"Мои билеты\""
#~ msgstr "Վճարման ID-ն բացակայում է:Գնված տոմսերը կարելի է դիտել \"Իմ տոմսերը\"բաժնում"

#: src/pages/order-details/order-details.page.tsx:133
#: src/pages/order-status/order-status.page.tsx:129
#: src/pages/ticket-details/ticket-details.page.tsx:152
msgid "Отсутствует ID платежа. Купленные билеты можно посмотреть в разделе \"Мои билеты\""
msgstr "Վճարման ID-ն բացակայում է:Գնված տոմսերը կարելի է դիտել \"Իմ տոմսերը\"բաժնում"

#: src/pages/push-notify-rate-trip/push-notify-rate-trip.page.tsx:90
msgid "Отсутствуют необходимые параметры в адресе страницы. Оцените поездку в приложении"
msgstr "Պահանջվող պարամետրերը բացակայում են էջի հասցեում: Գնահատեք ձեր ճանապարհորդությունը հավելվածում"

#: src/domains/feedback/reviews.page.tsx:177
msgid "Оцененные поездки"
msgstr "Գնահատված ուղևորություններ"

#: src/pages/push-notify-rate-trip/push-notify-rate-trip.page.tsx:78
#: src/pages/ticket-details/ticket-details.page.tsx:291
msgid "Оцените поездку"
msgstr "Գնահատեք ուղևորությունը"

#: src/domains/feedback/grade-title.ts:7
msgid "Оценка отсутствует"
msgstr "Գնահատականը բացակայում է"

#: src/domains/feedback/grade-title.ts:8
msgid "Очень плохо"
msgstr "Շատ վատ"

#: src/pages/main/notification-center.tsx:47
msgid "Очистить все"
msgstr "Очистить все"

#: src/pages/my-orders/my-orders.page.tsx:73
msgid "Ошибка"
msgstr "Սխալ"

#: src/pages/order-status/order-status.page.tsx:171
msgid "Ошибка при обработке заказа"
msgstr "Պատվերի մշակման սխալ"

#: src/domains/push-notify/use-push-notify-perms.ts:144
msgid "Ошибка при подписке на уведомления. Попробуйте позднее"
msgstr "Սխալ՝ ծանուցումներին բաժանորդագրվելիս: Փորձեք ավելի ուշ"

#: src/domains/sign-in/sign-in.tsx:122
#: src/domains/sign-up/sign-up.tsx:139
msgid "Пароль"
msgstr "Գաղտնաբառ"

#: src/pages/reset-password/reset-password.page.tsx:160
msgid "Пароль был успешно изменен"
msgstr "Գաղտնաբառը հաջողությամբ փոխվել է"

#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:39
msgid "Пассажир"
msgstr "Ուղևոր"

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:109
#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:25
msgid "Пассажиры"
msgstr "Ուղևորներ"

#: src/domains/buy-ticket/redirect-to-bank.tsx:24
#: src/pages/order-status/order-status.page.tsx:234
msgid "Перейти к оплате"
msgstr "Անցնել վճարման"

#: src/domains/buy-ticket/select-seats.tsx:111
msgid "Перейти к оформлению"
msgstr "Անցնել ձևակերպման"

#: src/pages/buy-tickets/buy-tickets.tsx:30
msgid "Переход к банку"
msgstr "Անցում բանկ"

#: src/domains/feedback/grade-title.ts:9
msgid "Плохо"
msgstr "Վատ"

#: src/pages/search/search.page.tsx:142
msgid "Повторить поиск"
msgstr "Կրկնել որոնումը"

#: src/domains/push-notify/push-notify-settings.tsx:53
msgid "Подписка на уведомления"
msgstr "Բաժանորդագրվել ծանուցումներին"

#: src/pages/buy-tickets/buy-tickets.tsx:28
msgid "Подтверждение платежа"
msgstr "Վճարման հաստատում"

#: src/domains/feedback/reviews.page.tsx:131
msgid "Поездки без отзыва"
msgstr "Առանց կարծիքի ուղևորություններ"

#: src/domains/feedback/reviews.page.tsx:73
#: src/domains/feedback/reviews.page.tsx:113
msgid "Поездки пока что отсутствуют"
msgstr "Դեռևս ուղևորություններ չկան"

#: src/domains/feedback/add-feedback-form.tsx:40
msgid "Пожалуйста, выберите оценку"
msgstr "Խնդրում ենք ընտրել գնահատականը"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:68
#: src/domains/available-routes/features/available-routes/available-routes.tsx:74
#: src/domains/reset-password/change-pass.form.tsx:28
#: src/domains/reset-password/change-pass.form.tsx:29
#: src/domains/reset-password/login.form.tsx:18
#: src/domains/sign-in/sign-in.tsx:36
#: src/domains/sign-in/sign-in.tsx:37
#: src/domains/sign-up/sign-up.tsx:97
#: src/domains/sign-up/sign-up.tsx:98
#: src/domains/sign-up/sign-up.tsx:109
msgid "Пожалуйста, заполните поле"
msgstr "Խնդրում ենք լրացնել դաշտը"

#: src/domains/sign-up/sign-up.tsx:103
msgid "Пожалуйста, проверьте правильность email"
msgstr "Խնդրում ենք ստուգել, ձեր էլ.փոստը ճիշտ է՞"

#: src/features/main-side-menu/main-side-menu.tsx:27
msgid "Поиск билетов"
msgstr "Տոմսերի որոնում"

#: src/pages/search/search.page.tsx:44
msgid "Поиск маршрутов"
msgstr "Երթուղիների որոնում"

#: src/components/ticket-qr/ticket-qr.tsx:20
msgid "Покажите QR код проводнику в поезде"
msgstr "Ցույց տվեք QR կոդը գնացքում ուղեկցողին"

#: src/pages/order-status/order-status.page.tsx:265
#~ msgid "Покажите его сотруднику ЮКЖД на просьбу предъявить билет"
#~ msgstr "Ցույց տվեք այն ՀԿԵ աշխատակցին, երբ նա խնդրում է տոմս ներկայացնել"

#: src/pages/my-tickets/my-tickets.page.tsx:114
#: src/pages/order-details/order-details.page.tsx:359
#: src/pages/order-status/order-status.page.tsx:344
msgid "Показать билет"
msgstr "Ցույց տալ տոմսը"

#: src/pages/my-tickets/my-tickets.page.tsx:113
#~ msgid "Показать данные билета"
#~ msgstr "Ցույց տալ տոմսի տվյալները"

#: src/pages/my-orders/my-orders.page.tsx:203
#~ msgid "Показать данные заказа"
#~ msgstr "Ցույց տալ պատվերի տվյալները"

#: src/pages/my-orders/my-orders.page.tsx:203
msgid "Показать заказ"
msgstr "Ցույց տալ պատվերի"

#: src/pages/order-details/order-details.page.tsx:318
#: src/pages/ticket-details/ticket-details.page.tsx:387
msgid "Попробуйте обновить статус, либо проверить купленные билеты в разделе \"Мои билеты\""
msgstr "Փորձեք թարմացնել կարգավիճակը կամ ստուգել գնված տոմսերը \"Իմ տոմսերը\"բաժնում"

#: src/pages/order-status/order-status.page.tsx:237
msgid "Попробуйте обновить статус, либо проверить купленные билеты в разделе <0>Мои билеты</0>"
msgstr "Փորձեք թարմացնել ձեր կարգավիճակը կամ ստուգել ձեր գնած տոմսերը <0>Իմ տոմսերը</0> բաժնում"

#: src/components/tickets-count/tickets-count.tsx:71
msgid "Попробуйте проверить или выбрать другой маршрут"
msgstr "Փորձեք ստուգել կամ ընտրել այլ երթուղի"

#: src/components/tickets-price/tickets-price.tsx:68
msgid "После оплаты Вам будет доступен QR-код. Покажите его сотруднику ЮКЖД в поезде на просьбу предъявить билет для проверки"
msgstr "Վճարումից հետո  Ձեզ հասանելի կլինի QR կոդը:Ցույց տվեք այն ՀԿԵ աշխատակցին, երբ նա խնդրում է տոմս ներկայացնել ստուգելու համար"

#: src/domains/feedback/reviews.page.tsx:220
msgid "Посмотреть отзыв"
msgstr "Տեսնել կարծիքը"

#: src/domains/shared/refund-fee-express.tsx:35
msgid "При возврате билета за <0>1</0> час до отправления поезда от стоимости билета с пассажира удерживается <1>750</1> драм."
msgstr "Գնացքի մեկնելուց առաջ մինչև <0>1</0> ժամ տոմսը վերադարձնելու դեպքում ուղևորի տոմսի արժեքից գանձվում է <1>750</1> դրամ։"

#: src/domains/shared/refund-fee-express.tsx:23
msgid "При возврате билета за <0>24</0> часа до отправления поезда от стоимости билета с пассажира удерживается <1>300</1> драм."
msgstr "Գնացքի մեկնելուց առաջ մինչև <0>24</0> ժամ տոմսը վերադարձնելու դեպքում ուղևորի տոմսի արժեքից գանձվում է <1>300</1> դրամ։"

#: src/domains/shared/refund-fee-express.tsx:29
msgid "При возврате билета за <0>6</0> часов до отправления поезда от стоимости билета с пассажира удерживается <1>500</1> драм."
msgstr "Գնացքի մեկնելուց առաջ մինչև <0>6</0> ժամ տոմսը վերադարձնելու դեպքում ուղևորի տոմսի արժեքից գանձվում է <1>500</1> դրամ։"

#: src/domains/buy-ticket/agreement.tsx:20
msgid "При возврате группового билета возврату подлежат все места. Возврат отдельного места не производится."
msgstr "Խմբային տոմսը վերադարձնելիս վերադարձի ենթակա են բոլոր տեղերը, առանձին տեղը վերադարձ չի կատարվում:"

#: src/pages/order-details/order-details.page.tsx:267
#: src/pages/order-status/order-status.page.tsx:178
#: src/pages/ticket-details/ticket-details.page.tsx:351
msgid "При обработке платежа произошла ошибка"
msgstr "Վճարումը մշակելիս սխալ է տեղի ունեցել"

#: src/components/search-route-card/search-route-card-data.tsx:34
msgid "Приобрести билеты"
msgstr "Ձեռք բերել տոմսեր"

#: src/domains/buy-ticket/buy-ticket.tsx:235
msgid "Продолжить"
msgstr "Շարունակեք"

#: src/pages/buy-tickets/buy-tickets.tsx:32
msgid "Пустой заголовок"
msgstr "Դատարկ վերնագիր"

#: src/domains/tz-notify/tz-notify.tsx:20
msgid "Расписание движения поездов не изменится."
msgstr "Գնացքների չվացուցակը չի փոխվի."

#: src/pages/main/main.page.tsx:103
#: src/pages/sign-up/sign-up.page.tsx:49
msgid "Регистрация"
msgstr "Գրանցում"

#: src/domains/tz-notify/tz-notify.tsx:11
msgid "С 08.10.2023 на сайте будет отображаться <0>местное время <1>(г. Ереван, GMT+4)</1></0> для отправления и прибытия поездов."
msgstr "08.10.2023-ից գնացքների մեկնման և ժամանման համար, կայքում կցուցադրվի <0> տեղական ժամանակը<1>(ք.Երևան, GMT+4)</1></0>."

#: src/pages/reset-password/reset-password.page.tsx:120
msgid "Сброс пароля"
msgstr "Գաղտնաբառի թարմացում"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:65
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:72
msgid "Скрыть заказ"
msgstr "Թաքցնել պատվերը"

#: src/domains/buy-ticket/select-payment-type.tsx:12
msgid "Создать платеж"
msgstr "Ստեղծել վճարում"

#: src/components/ui/ui-fullscreen-select/select-search-list.tsx:51
msgid "Станции отсутствуют"
msgstr "Կայարանները բացակայում են"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:153
msgid "Станция назначения"
msgstr "նշանակման կայարան"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:152
msgid "Станция отправления"
msgstr "Մեկնման կայարան"

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:32
msgid "Стоимость"
msgstr "Արժեքը"

#: src/pages/order-details/order-details.page.tsx:51
#: src/pages/order-status/order-status.page.tsx:363
msgid "Стоимость билетов"
msgstr "Տոմսերի արժեքը"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:47
msgid "Стоимость оплаченного билета будет возвращена с помощью выбранного способа оплаты (банковская карта)"
msgstr "Վճարված տոմսի արժեքը կվերադարձվի ընտրված  եղանակով (բանկային քարտ)"

#: src/router/router.tsx:171
msgid "Страница не найдена"
msgstr "Էջը չի գտնվել"

#: src/components/tickets-price/tickets-price.tsx:55
msgid "Сумма"
msgstr "Գումար"

#: src/pages/my-orders/my-orders.page.tsx:191
msgid "Сумма:"
msgstr "Գումար."

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:175
#: src/pages/ticket-details/ticket-details.page.tsx:286
msgid "Тарифы"
msgstr "Սակագներ"

#: src/pages/reset-password/reset-password.page.tsx:163
msgid "Теперь вы можете войти в личный кабинет используя новый пароль"
msgstr "Այժմ Դուք կարող եք այցելել Ձեր անձնական գրասենյակը՝ օգտագործելով նոր գաղտնաբառը"

#: src/pages/ticket-details/trip-data/trip-data.tsx:30
msgid "Тип состава"
msgstr "Շարժակազմի տեսակը"

#: src/domains/feedback/reviews.page.tsx:121
msgid "У вас нет отзывов о поездках или нет поездок, которые можно оценить."
msgstr "Դուք չունեք ուղևորությունների վերաբերյալ կարծիքներ կամ ուղևորություններ, որոնք կարելի է գնահատել:"

#: src/domains/push-notify/push-notify-access-request.tsx:46
#: src/domains/push-notify/push-notify.page.tsx:34
#: src/domains/push-notify/use-push-notify-perms.ts:233
#: src/pages/main/notification-center.tsx:35
msgid "Уведомления"
msgstr "Ծանուցումներ"

#: src/domains/feedback/grade-title.ts:10
msgid "Удовлетворительно"
msgstr "Բավարար"

#: src/pages/sign-up/sign-up.page.tsx:81
msgid "Уже зарегистрированны?"
msgstr "Արդեն գրանցվա՞ծ եք"

#: src/pages/buy-tickets/buy-tickets.tsx:26
msgid "Условия возврата"
msgstr "Վերադարձի քաղաքականություն"

#: src/domains/feedback/grade-title.ts:11
msgid "Хорошо"
msgstr "Լավ"

#: src/domains/feedback/add-feedback-form.tsx:54
msgid "Хотите оставить сообщение?"
msgstr "Ցանկանու՞մ եք հաղորդագրություն թողնել:"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:81
msgid "Что-то пошло не так. Неизвестный статус заказа"
msgstr "ինչ որ բան այնպես չգնաց. Պատվերի անհայտ կարգավիճակ"

#: src/pages/main/main.page.tsx:85
msgid "Электрички Армении"
msgstr "Հայաստանի Էլեկտրագնացքներ"

#: src/pages/order-status/order-status.page.tsx:262
#~ msgid "Это QR-код вашего заказа"
#~ msgstr "Սա Ձեր պատվերի QR կոդն է"
